import { render, staticRenderFns } from "./DashboardBeauty.vue?vue&type=template&id=43368f7a&scoped=true"
import script from "./DashboardBeauty.vue?vue&type=script&lang=js"
export * from "./DashboardBeauty.vue?vue&type=script&lang=js"
import style0 from "./DashboardBeauty.vue?vue&type=style&index=0&id=43368f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43368f7a",
  null
  
)

export default component.exports